<div class="css-Combo_especial_correo-1 combo_especial_correo">
    <p class="css-Etiqueta etiqueta">La respuesta se enviará a la siguiente dirección de correo:</p>
    <div class="css-Conjunto_correo conjunto_correo">
        <!-- <p class="css-Correo_default correo_default">direccióndecorreo.largo@maail.com.uy</p> -->
        <app-item-correo *ngFor="let correo of correos" correo={{correo}}
            (eliminarCorreoEmitter)="eliminarCorreoEmitter($event)"></app-item-correo>
    </div>
    <div class="css-Enlace_icono_izquierda-1 enlace_icono_izquierda" *ngIf="!agregando_direccion">
        <a class="css-a_Enlace_icono_izquierda-1 a_enlace_icono_izquierda" (click)="nuevaDireccion()">
            <div class="css-Iconos_Mas iconos_mas">
                <img src="assets/images/basecomponents-images/combo-espeeial-correo.svg" width="10px" height="10px"
                    class="css-Vector_add vector_add">
            </div>
            <p class="css-Texto_enlace-1 texto_enlace">Agregar otra dirección de correo</p>
        </a>
    </div>
    <div class="css-Campo_Default_Con_Accion-1 campo_default_con_accion" *ngIf="agregando_direccion">
        <input type="text" [(ngModel)]="model_value" class="css-input_text_Campo-1 input_text_campo"
            name="comp_campo_default_con_accion">
        <a class="css-a_Accion-1 a_accion" (click)="agregar()">Agregar</a>
    </div>
    <div class="css-mensaje_error mensaje_error error-off" *ngIf="mensaje_error.length>0">
        <div class="css-Icono_Error_Forms-1 icono_error_forms">
            <img src="assets/images/basecomponents-images/campo-default.svg" width="9px" height="9px"
                class="css-close close">
        </div>
        <p class="css-Texto-1 texto">{{mensaje_error}}</p>
    </div>
</div>